import type { ReasonToMessageMap } from "../common/types";
import type { ReferenceActionUnavailableReason } from "./types";

export const referenceReasonToMessageMap: ReasonToMessageMap<ReferenceActionUnavailableReason> = {
	ACL_EDITOR_REQUIRED: (count) =>
		count === 1
			? `${count} reference is excluded because the user does not have the necessary permissions to perform this action.`
			: `${count} references are excluded because the user does not have the necessary permissions to perform this action.`,

	ACL_OWNER_REQUIRED: () => "You are not the owner",
	LINKED_TO_PORTFOLIO: (count) =>
		count === 1
			? `${count} reference is linked to a portfolio and cannot be deleted.`
			: `${count} references are linked to portfolios and cannot be deleted.`,
	LEGACY_BENCHMARK: (count) =>
		count === 1
			? `${count} legacy benchmark is excluded from the Bulk Sphere template`
			: `${count} legacy benchmarks are excluded from the Bulk Sphere template`,
};
